/*
    Metric.js - Metrics model
 */

import {Rest} from '@/paks/vu-app'
import {State} from '@/paks/vu-app'

class Metric {
    constructor() {
        this.rest = new Rest(
            'Metric',
            {
                fetch: {method: 'POST', uri: '/:controller/fetch'},
                getMetricList: {method: 'POST', uri: '/:controller/getMetricList'},
            },
            {cache: false}
        )
    }
    async fetch(items) {
        this.addContext(items)
        return this.rest.fetch(items)
    }
    
    async getMetricList(params) {
        return this.rest.getMetricList(params)
    }

    addContext(items) {
        if (State.app.context.deviceId) {
            items.deviceId = State.app.context.deviceId
        }
    }
}

export default new Metric()
